import React from 'react'
import SuggestionsMenuListItem from '../SuggestionsMenuListItem'

interface SuggestionsMenuListProps {
  items: string[]
  handleClose?: () => void
  askHandler?: (utterance: string) => void
  askTimeout?: number
  areRowsContained?: boolean
}

const SuggestionsMenuList: React.FC<SuggestionsMenuListProps> = ({
  items,
  handleClose,
  askHandler,
  askTimeout,
  areRowsContained
}) => {
  return (
    <React.Fragment>
      {items.map((utterance: string, index: number) => (
        <div key={`item-${index}`}>
          <SuggestionsMenuListItem
            utterance={utterance}
            index={index}
            handleClose={handleClose}
            askHandler={askHandler}
            askTimeout={askTimeout}
            areRowsContained={areRowsContained}
          />
        </div>
      ))}
    </React.Fragment>
  )
}

export default SuggestionsMenuList
